import { defineStore } from 'pinia';
import {
  applyColorScheme,
  browserStorage,
  oppositeColorScheme,
  readColorSchemePreference,
  resolveColorScheme,
  systemPrefersDark,
  writeColorSchemePreference,
  type ColorScheme,
  type ColorSchemePreference,
} from '@features/tenant/colorScheme';

interface ColorSchemeState {
  preference: ColorSchemePreference;
  systemDark: boolean;
}

export const useColorSchemeStore = defineStore('colorScheme', {
  state: (): ColorSchemeState => ({
    preference: readColorSchemePreference(browserStorage(window)),
    systemDark: systemPrefersDark(window),
  }),

  getters: {
    scheme: (state): ColorScheme =>
      resolveColorScheme(state.preference, state.systemDark),
  },

  actions: {
    paint() {
      applyColorScheme(document.documentElement, this.scheme);
    },

    set(preference: ColorSchemePreference) {
      this.preference = preference;
      writeColorSchemePreference(browserStorage(window), preference);
      this.paint();
    },

    toggle() {
      this.set(oppositeColorScheme(this.scheme));
    },

    followSystem(systemDark: boolean) {
      this.systemDark = systemDark;
      this.paint();
    },
  },
});
